var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetPointOfInterestLarge',{attrs:{"title":_vm.pointOfInterest.title,"preview-image-url":_vm.pointOfInterest.previewImageUrl,"long-rich-text":_vm.pointOfInterest.longRichText,"tour360-to":_vm.exteriorTour360RouteObject,"share-url":_vm.currentUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }